// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__joBYQ","label":"Category_label__1sv0M","content":"Category_content__2cwsv","header":"Category_header__3aoiE","location":"Category_location__1Jyob"};